<script>
	export let data;

	//Title Case from snake_case
	function displayKey(key) {
		key = key.replace(/_/g, ' ');
		return key.replace(/\w\S*/g, (m) => m.charAt(0).toUpperCase() + m.substr(1).toLowerCase());
	}
</script>

{#if data}
	{#each Object.entries(data) as [key, value]}
		{#if value}
			<div class="pb-1">
				<span class="font-semibold">{displayKey(key)}:</span>
				<span class="">{JSON.stringify(value)}</span>
			</div>
		{/if}
	{/each}
{/if}
